export const history = [
  {
    year: "2016",
    items: [
      {
        title: "특강",
        list: [
          "농림축산식품부 농업마케팅전략 특강",
          "국립중앙도서관 사서 연수과정 강의, 강사 위촉",
          "고려대 온라인마케팅 강의, 온라인마케팅 과정 우수강사 선정",
          "한국금융연수원 BNK 소셜미디어 전략 특강",
          "교촌치킨 마케팅 강의",
        ],
      },
      {
        title: "TV출연",
        list: [
          "MBC '경제매거진M' 인터뷰",
          "MBC 라디오 '손에 잡히는 경제' 인터뷰",
          "연합뉴스(YTN) '사이언스' 인터뷰",
        ],
      },
      {
        title: "프랜차이즈 컨설팅",
        list: [
          "농협 '풍산김치' 컨설팅",
          "죽염명가 '인산가' 컨설팅",
          "땅땅치킨 컨설팅",
          "서울시 청년상인, 전통시장 활성화 사업 컨설팅",
        ],
      },
    ],
  },
  {
    year: "2015",
    items: [
      {
        title: "특강",
        list: [
          "유니시티 특강",
          "여성능력개발센터 마케팅 컨설팅",
          "동부그룹 마케팅 특강",
          "한국금융연수원 SNS마케팅 전략과정 특강",
          "조달청 나라장터 입접업체 특강",
          "빅데이터 국제포럼 강의",
          "고려대학교 온라인마케팅 강의",
          "교촌치킨 영업전략회의 특강",
          "고려대 온라인마케팅 최고경영자과정 외래교수 임명",
        ],
      },
      {
        title: "TV출연",
        list: [
          "KBS 2TV 생방송 '아침' 인터뷰",
          "생생정보통 '가격을 맞춰라' 출연",
        ],
      },
      {
        title: "프랜차이즈 컨설팅",
        list: ["BBQ그룹 2014년 매출상승 기여로 감사패 수여", "땅땅치킨 컨설팅"],
      },
      {
        title: "기타",
        list: [
          "페이스북, 카카오스토리 마케팅 비법 책 출간 및 베스트셀러 선정",
          "모바일마케팅, 상위노출비법 최재봉 작가 책 출간",
        ],
      },
    ],
  },
  {
    year: "2014",
    items: [
      {
        title: "특강",
        list: [
          "소자본창업 성공 마케팅비법 특강, 경기여성능력개발센터",
          "서울시청 뉴미디어실 마케팅 특강",
          "유니시티 특강",
          "세종대학교 최고경영자과정 책임지도교수 특강",
          "취업사이트 '사람인'에서 마케팅멘토로 선정",
          "충남 전지역 중고차 사업자 대상 특강",
        ],
      },
      {
        title: "TV출연",
        list: ["KBS 생생정보통에 최재봉교수 마케팅전문가로 인터뷰"],
      },
      {
        title: "수상",
        list: [
          "서울특별시에서 진행하는 소셜특별시 자문위원으로 위촉",
          "정부지원사업 RIS남원옻칠, 산업통산자원부 장관 표창",
        ],
      },
    ],
  },
  {
    year: "2013",
    items: [
      {
        title: "특강",
        list: [
          "여성능력개발원 마케팅 특강",
          "한남대학교에서 마케팅전문가로 특강",
          "정부지원 충북펜션&민박 대표님들 대상 바이럴마케팅 특강진행",
          "부산 벡스코에서 해외마케팅전략 특강",
          "네이버에서 SNS마케팅 전문강사로 특강",
          "네이버본사 공식강사로 마케팅특강",
          "네이버 키워드광고 칼럼리스트 선정",
          "BBQ그룹 공채 21기 신입사원 교육",
          "김제시 농업기술센터 특강",
          "세종대 페이스북, 마케팅 특강",
          "세종대학교 세종CEO 바이럴마케팅과정 지도교수로 임명",
          "더케이손해보험 마케팅 자문역",
          "iCEO타임즈 편집인",
          "잡코리아 토크쇼, 나꿈쇼 특강",
          "강남구청에서 운영하는 강남 경제포럼 특강",
        ],
      },
      {
        title: "프랜차이즈 컨설팅",
        list: [
          "강남 자동차 매매 단지와 마케팅 제휴계약 체결",
          "제네시스BBQ 본사 마케팅 고문",
        ],
      },
      {
        title: "수상",
        list: [
          "최재봉 신지식인 서울중소기업청장상 수상",
          "중소기업지원센터 홍보대사 위촉",
          "서울지방중소기업청장 표창",
          "경기중소기업종합지원센터 GSBC아카데미 교육과정 마케팅영업분야 최우수강사",
          "한국신지식인협회 대한민국 신지식인",
          "경기 중소기업지원센터 최우수 전문가 선정",
        ],
      },
      {
        title: "기타",
        list: [
          "인터넷쇼핑몰 마케팅비법 책 출간",
          "인터넷쇼핑몰 실전마케팅 책 출간",
        ],
      },
    ],
  },
  {
    year: "2012",
    items: [
      {
        title: "특강",
        list: [
          "서울예술대학교에서 블로그마케팅 특강",
          "경기여성능력개발센터에서 마케팅 강의",
          "남원옻칠사업단 마케팅 특강",
          "부림중학교 마케팅 직업 특강",
          "계원예술대학교 공간연출과 마케팅 특강",
          "경기중소기업지원센터 마케팅 교수 및 강의",
          "부산 신라대학교에서 마케팅 특강",
          "GSBC아카데미 마케팅영업분야 강사",
          "iCEO실전마케팅연구소 대표",
          "비즈인포그룹 대표",
          "한중수교 20주년 기념 한국기업 대표로 참석",
        ],
      },
      {
        title: "기타",
        list: ["인터넷쇼핑몰 마케팅비법 책 출간 및 주간 베스트셀러 선정"],
      },
    ],
  },
  {
    year: "2011",
    items: [
      {
        title: "특강",
        list: [
          "경북도청 경제진흥원 주최 300명의 참석자에게 마케팅 방법 전수",
          "한국농어촌공사 마케팅 강사로 위촉",
        ],
      },
    ],
  },
  {
    year: "2009",
    items: [
      {
        title: "기타",
        list: ["인터넷 쇼핑몰 실전 마케팅 무작정 따라하기 출간"],
      },
    ],
  },
];
